/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EStartLocationSource {
  FromUserSettings = 1,
  FromUserPlots = 2
}
